
    import { register } from "https://d2r3ahc54mheuc.cloudfront.net/latest/WebComponents.js";
    register();
  